<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{$route.meta.title}}
                    </div>
                    <board-list-component :boardType="'jstQna'"></board-list-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BoardListComponent from "../../components/board/BoardListComponent";
export default {
    name: "JstQna",
    mixins: [],
    components: {
        BoardListComponent
    },
    inject: [],
    provide() {
        return{

        }
    },
    props: {
    },
    data() {
        return{

        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{

    },
    watch: {

    },
}
</script>

<style scoped>

</style>